import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { QRCodeWrapperModule } from '../shared/qrcode-wrapper.module';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';

import {
  ClientListComponent,


  ClientFeaturesComponent,
  ClientDetailComponent,
  ClientComponent,
  ClientUsersComponent,
  ClientUserComponent,
  ClientPermissionsComponent,
  ClientAIUsageComponent,
  ClientCompaniesComponent

} from '.';


function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}


const routes: Routes = [
  
   {
    path: 'client/:ID',
    component: ClientComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: ClientDetailComponent, canActivate: [AuthGuard] }, //Overview
      { path: 'Users', component: ClientUsersComponent, canActivate: [AuthGuard] }, //Users
      { path: 'User/:UserID', component: ClientUserComponent, canActivate: [AuthGuard] },
      { path: 'Permissions', component: ClientPermissionsComponent, canActivate: [AuthGuard] }, //Permissions
      { path: 'Settings', component: ClientFeaturesComponent, canActivate: [AuthGuard] }, // Features & Settings
      { path: 'AIUsage', component: ClientAIUsageComponent, canActivate: [AuthGuard] }, // AI Usage
      { path: 'Companies', component: ClientCompaniesComponent, canActivate: [AuthGuard] }, // Companies
    ]
  },

  { path: 'clients', component: ClientListComponent, canActivate: [AuthGuard] },
  
  
];

const pages = [
  ClientListComponent,


  ClientComponent,
  ClientDetailComponent,
   ClientUsersComponent,
    ClientFeaturesComponent,
    ClientPermissionsComponent,
    ClientUserComponent,
    ClientAIUsageComponent,

    ClientCompaniesComponent

];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QRCodeWrapperModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ...pages
  ],
  providers: []
})
export class ClientsModule { 
  constructor(@Optional() @SkipSelf() parentModule: ClientsModule) {
    if (parentModule) {
      throw new Error('Module is already loaded. Import in your base AppModule only.');
    }
  }
}
